{
	"actions": {
		"save": "Save",
		"cancel": "Cancel",
		"delete": "Delete",
		"edit": "Edit",
		"create": "Create",
		"confirm": "Confirm",
		"back": "Back",
		"next": "Next",
		"done": "Done",
		"close": "Close",
		"open": "Open",
		"retry": "Retry",
		"copy": "Copy",
		"share": "Share",
		"download": "Download",
		"upload": "Upload",
		"search": "Search",
		"filter": "Filter",
		"sort": "Sort",
		"select": "Select",
		"selectAll": "Select all",
		"clearAll": "Clear",
		"apply": "Apply",
		"reset": "Reset",
		"more": "More",
		"showMore": "Show more",
		"showLess": "Show less",
		"expand": "Expand",
		"collapse": "Collapse",
		"viewAll": "View all",
		"menu": "Actions menu"
	},
	"state": {
		"loading": "Loading…",
		"loadingApp": "Loading the app…",
		"saving": "Saving…",
		"processing": "Processing…",
		"empty": "Empty",
		"error": "Error",
		"success": "Done",
		"noResults": "No results",
		"comingSoon": "Coming soon"
	},
	"generation": {
		"progress": "{percent}%",
		"etaApprox": "~",
		"etaSeconds": "{prefix}{count}s",
		"etaMinutes": "{prefix}{count}m",
		"partialCoverageTitle": "Partial source coverage",
		"partialCoverageBody": "The source is large — this was generated from part of it. Split the material or narrow the scope to cover everything."
	},
	"yesNo": {
		"yes": "Yes",
		"no": "No"
	},
	"confirm": {
		"trashTitle": "Move “{name}” to Trash?",
		"trashTitleGeneric": "Move material to Trash?",
		"trashDescription": "You can restore it from Trash within 30 days.",
		"deleteTitle": "Delete “{name}”?",
		"deleteTitleGeneric": "Delete item?",
		"deleteDescription": "This action cannot be undone.",
		"moveToTrash": "To Trash"
	},
	"time": {
		"now": "now",
		"today": "today",
		"yesterday": "yesterday",
		"tomorrow": "tomorrow",
		"thisWeek": "this week",
		"older": "earlier",
		"minutesAgo": "{count, plural, one {# minute ago} other {# minutes ago}}",
		"hoursAgo": "{count, plural, one {# hour ago} other {# hours ago}}",
		"daysAgo": "{count, plural, one {# day ago} other {# days ago}}"
	},
	"units": {
		"items": "{count, plural, =0 {No items} one {# item} other {# items}}",
		"minutes": "{count, plural, one {# minute} other {# minutes}}",
		"seconds": "{count, plural, one {# second} other {# seconds}}",
		"bytes": "{count} B",
		"kilobytes": "{count} KB",
		"megabytes": "{count} MB"
	},
	"offline": {
		"banner": "Offline · working in local mode",
		"bannerWithQueue": "Offline · {count, plural, one {# action} other {# actions}} queued",
		"writeBlocked": "Internet connection required",
		"queued": "Queued for send",
		"sendFailed": "Failed to send — tap to retry",
		"waitingForNetwork": "Waiting for connection…",
		"autoRetry": "Reconnecting…",
		"syncingLibrary": "Syncing your library…",
		"syncInitializing": "Preparing your library…",
		"syncFirstRunHint": "First load after an update — this can take up to a minute",
		"syncConnecting": "Connecting to sync…",
		"syncDownloading": "Downloading your library…",
		"syncDownloadingPercent": "Downloading your library… {percent}% ({downloaded}/{total})",
		"syncDownloadingPending": "Downloading your library… {count, plural, one {# item pending} other {# items pending}}",
		"syncError": "Sync error — check your connection",
		"syncIssuesAction": "View sync issues",
		"changesDroppedWithCenter": "{count, plural, one {# change} other {# changes}} could not be saved — review in sync issues",
		"mediaUnavailable": "Image unavailable offline",
		"mediaUnavailableHint": "Reconnect to load media",
		"changesDropped": "{count, plural, one {# change} other {# changes}} could not be saved to the server and were discarded",
		"noCachedCopy": "This item isn't available offline",
		"noCachedCopyHint": "It hasn't been downloaded to this device yet. Reconnect to open it."
	},
	"quota": {
		"remaining": "left"
	},
	"appUpdate": {
		"available": "A new version is available",
		"action": "Update",
		"forced": "Updating the app…"
	},
	"view": {
		"label": "View mode",
		"grid": "Cards",
		"list": "List"
	},
	"regenerate": {
		"confirmTitle": "Regenerate?",
		"confirmAction": "Regenerate",
		"note": "The current note will be replaced with a new version. The previous one stays in version history.",
		"material": "The note, flashcards, quiz and glossary for this material will be regenerated and replace the current ones. This is a costly AI operation — it consumes several generations from your quota at once.",
		"audio": "The current audio recap will be replaced with a new version.",
		"collection": "The current folder-wide artifact will be replaced with a new version."
	},
	"status": {
		"queued": "Queued",
		"processing": "Processing",
		"ready": "Ready",
		"partial": "Partial",
		"error": "Error",
		"trial": "Trial",
		"pro": "Pro",
		"plus": "Plus",
		"free": "Free"
	},
	"pagination": {
		"previous": "Previous",
		"next": "Next",
		"morePages": "More pages",
		"label": "Pagination",
		"page": "Page {page}"
	},
	"errors": {
		"404": {
			"title": "Page not found",
			"description": "The page you are looking for does not exist or has been moved.",
			"backToHome": "Back to home"
		},
		"generic": "Something went wrong. Please try again.",
		"boundary": {
			"title": "Something went wrong",
			"body": "An unexpected error occurred. We're already aware of it. Try reloading the page.",
			"reload": "Reload",
			"retry": "Try again"
		},
		"notFound": {
			"title": "Page not found",
			"description": "The link may be outdated or the page was removed.",
			"home": "Back to home"
		},
		"server": {
			"title": "Server unavailable",
			"description": "Please refresh the page in a few seconds.",
			"retry": "Try again"
		},
		"chunkLoad": {
			"title": "Couldn't load this screen",
			"bodyOffline": "This section isn't available offline yet. We'll retry when you're back online.",
			"bodyOnline": "Failed to load the page module. Try again.",
			"retry": "Try again"
		}
	},
	"player": {
		"play": "Play",
		"pause": "Pause",
		"rate": "Playback speed",
		"close": "Close player"
	},
	"upgrade": {
		"title": "Unlock Plus",
		"description": "Unlimited AI, voice tutor, and advanced quizzes.",
		"cta": "Learn more"
	},
	"combobox": {
		"placeholder": "Select…",
		"search": "Search…",
		"empty": "No results"
	},
	"magicMoment": {
		"title": "Creating your material…",
		"cancel": "Cancel"
	},
	"streakCard": {
		"day": "day streak",
		"days": "days streak"
	},
	"citation": {
		"page": " · p. {page}"
	},
	"shell": {
		"expandSidebar": "Expand sidebar",
		"collapseSidebar": "Collapse sidebar"
	},
	"materialCard": {
		"favorite": "Add to favorites",
		"unfavorite": "Remove from favorites",
		"menu": "Menu"
	},
	"rating": {
		"again": "Again",
		"hard": "Hard",
		"good": "Good",
		"easy": "Easy"
	},
	"dataTable": {
		"empty": "No data"
	},
	"actionBar": {
		"label": "Action bar"
	},
	"wizard": {
		"stepsLabel": "Steps",
		"goToStep": "Back to step “{label}”"
	},
	"price": {
		"free": "Free"
	},
	"sync": {
		"pendingBanner": "Not synced: {count, plural, one {# item} other {# items}} — sending",
		"localDbLost": {
			"message": "The browser lost access to data on this device. Reload the page to continue.",
			"action": "Reload"
		}
	},
	"whatIsThis": "What is this?",
	"sectionIntro": {
		"dismiss": "Got it",
		"reopen": "What is this section"
	},
	"method": {
		"step1": {
			"ordinal": "1",
			"label": "Understand"
		},
		"step2": {
			"ordinal": "2",
			"label": "Check"
		},
		"step3": {
			"ordinal": "3",
			"label": "Close the gaps"
		}
	},
	"account": {
		"points": "Points",
		"pointsApproximate": "Balance may be out of date",
		"iecPlusHint": "Your level across the ecosystem"
	}
}
